import { jsx as _jsx } from "react/jsx-runtime";
import { useRef, useState, useMemo } from 'react';
import classnames from 'classnames';
import useConfig from '../../hooks/useConfig';
import useScrollParent from '../../hooks/useScrollParent';
import useScroll from '../../hooks/useScroll';
import useVisibilityChange from '../../hooks/useVisibilityChange';
import { isHidden, getRect } from '../../utils/dom';
var cls = 'sticky';

var Sticky = function Sticky(props) {
  var _useState = useState({
    fixed: false,
    width: 0,
    height: 0,
    transform: 0
  }),
      state = _useState[0],
      setState = _useState[1];

  var _useConfig = useConfig(),
      createNamespace = _useConfig.createNamespace,
      prefixCls = _useConfig.prefixCls;

  var classes = classnames(createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace(cls, prefixCls), props.className);
  var containerClasses = classnames(createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace(cls + "-container", prefixCls), {
    fixed: state.fixed
  });
  var root = useRef(null);
  var scrollParent = useScrollParent(root);
  var rootStyle = useMemo(function () {
    var fixed = state.fixed,
        height = state.height,
        width = state.width;

    if (fixed) {
      return {
        width: width + "px",
        height: height + "px"
      };
    }

    return;
  }, [state]);
  var stickyStyle = useMemo(function () {
    if (!state.fixed) {
      return;
    }

    var style = {
      width: state.width + "px",
      height: state.height + "px",
      top: props.offset + "px"
    };

    if (state.transform) {
      style.transform = "translate3d(0, " + state.transform + "px, 0)";
    }

    return style;
  }, [state, props.offset]);

  var onScroll = function onScroll() {
    var _a;

    if (!root.current || isHidden(root.current)) {
      return;
    }

    var rootRect = getRect(root.current);
    var newState = {};
    newState.width = rootRect.width;
    newState.height = rootRect.height;

    if ((_a = props.container) === null || _a === void 0 ? void 0 : _a.current) {
      var containerRect = getRect(props.container.current);
      var difference = containerRect.bottom - props.offset - newState.height;
      newState.fixed = props.offset > rootRect.top && containerRect.bottom > 0;
      newState.transform = difference < 0 ? difference : 0;
    } else {
      newState.fixed = props.offset > rootRect.top;
    }

    setState(newState);
  };

  useScroll(scrollParent, onScroll);
  useVisibilityChange(root, onScroll);
  return _jsx("div", Object.assign({
    ref: root,
    style: rootStyle,
    className: classes
  }, {
    children: _jsx("div", Object.assign({
      style: stickyStyle,
      className: containerClasses
    }, {
      children: props.children
    }))
  }));
};

Sticky.displayName = 'Sticky';
Sticky.defaultProps = {
  offset: 0
};
export default Sticky;